export enum Locale {
  FR = 'fr-FR',
  US = 'en-US',
}
